export const SET_FONT = 'SET_FONT';
export const SET_ANGLE = 'SET_ANGLE';
export const SET_GENERATIONS = 'SET_GENERATIONS';
export const SET_MARGIN = 'SET_MARGIN';
export const SET_RADIUS = 'SET_RADIUS';
export const SET_STROKE_WIDTH = 'SET_STROKE_WIDTH';
export const SET_STROKE_COLOR = 'SET_STROKE_COLOR';
export const SET_ANGLE_OFFSET = 'SET_ANGLE_OFFSET';
export const SET_TEXT_TRANSFORM = 'SET_TEXT_TRANSFORM';
export const SET_THEMATIC = 'SET_THEMATIC';
export const SET_CHART_BACKGROUND = 'SET_CHART_BACKGROUND';

export const SET_HEADING = 'SET_HEADING';
export const SET_SUBHEADING = 'SET_SUBHEADING';
export const BATCH_UPDATE_CHART = 'BATCH_UPDATE_CHART';


// WEBPACK FOOTER //
// ./src/core/chart/action-types.js